<div id="section-main">
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center">
        <img src="assets/img/logo.png" alt="Logo" />
      </div>
    </div>
  </div>
</div>
